(() => {
  const init = (root) => {
    if (root.hasAttribute('data-ready')) return;

    const source = root.querySelector('[data-lp-bundle-config]');
    if (!source) return;

    let config;
    try {
      config = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    const inputs = Array.from(root.querySelectorAll('[data-lp-kit-input]'));
    const bar = root.querySelector('[data-lp-bundle-bar]');
    const countEl = root.querySelector('[data-lp-count]');
    const noteEl = root.querySelector('[data-lp-note]');
    const priceEl = root.querySelector('[data-lp-price]');
    const totalEl = root.querySelector('[data-lp-total]');
    const cta = root.querySelector('[data-lp-cta]');

    const options = new Map((config.options || []).map((option) => [option.key, option]));
    const variants = new Set(
      Array.from(options.values())
        .map((option) => String(option.variant))
        .filter(Boolean)
    );

    const syncsCart = config.mode === 'cart';
    const ctaAction = config.ctaAction || 'permalink';
    const ctaWritesCart = ctaAction !== 'permalink';

    const selected = () => inputs.filter((input) => input.checked);

    const keyOf = (chosen) =>
      chosen
        .map((input) => Number(input.dataset.slot))
        .filter((slot) => slot > 0)
        .sort((a, b) => a - b)
        .join('+');

    const inbound = () => new URLSearchParams(window.location.search);

    const permalinkUrl = (variant) => {
      const params = inbound();
      params.set('channel', 'buy_button');

      return `${config.cart}/${encodeURIComponent(variant)}:1?${params}`;
    };

    const withParams = (path) => {
      const params = inbound().toString();

      return params ? `${path}?${params}` : path;
    };

    const destination = (variant) => {
      if (ctaAction === 'cart') return withParams(config.cart);
      if (ctaAction === 'checkout') return withParams(config.checkout);

      return permalinkUrl(variant);
    };

    let current = null;
    let empty = true;
    let wanted = null;
    let queued = false;
    let chain = Promise.resolve();

    const ajax = (url, body) =>
      fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: body
          ? { 'Content-Type': 'application/json', Accept: 'application/json' }
          : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then((response) => (response.ok ? response.json() : Promise.reject(response)));

    const reconcile = () => {
      const target = wanted;

      return ajax(`${config.cart}.js`).then((cart) => {
        const updates = {};

        (cart.items || []).forEach((item) => {
          const id = String(item.variant_id);
          if (variants.has(id) && id !== target) updates[id] = 0;
        });

        if (target) {
          const line = (cart.items || []).find((item) => String(item.variant_id) === target);
          if (!line || line.quantity !== 1) updates[target] = 1;
        }

        if (!Object.keys(updates).length) return null;

        return ajax(`${config.cartUpdate}.js`, { updates });
      });
    };

    const sync = () => {
      if (!syncsCart || queued) return chain;

      queued = true;
      chain = chain
        .then(() => {
          queued = false;
          return reconcile();
        })
        .catch(() => {
          queued = false;
        });

      return chain;
    };

    const trigger = document.querySelector('.lp-hero__cta') || document.querySelector('.lp-hero');
    let triggerVisible = Boolean(trigger) && 'IntersectionObserver' in window;

    const syncBar = () => {
      if (!bar) return;

      bar.toggleAttribute('data-empty', empty);
      bar.toggleAttribute('data-visible', !triggerVisible || !empty);
    };

    const update = () => {
      const chosen = selected();
      const option = options.get(keyOf(chosen)) || null;
      const price = option ? option.price : '';
      current = option;
      empty = chosen.length === 0;
      wanted = option && option.variant ? String(option.variant) : null;

      if (countEl) {
        const template = (chosen.length === 1 ? config.labelOne : config.labelMany) || '';
        countEl.textContent = empty ? '' : template.replace('[count]', chosen.length);
        countEl.hidden = empty;
      }

      if (priceEl) priceEl.textContent = price;
      if (totalEl) totalEl.hidden = !price;

      if (noteEl) {
        noteEl.textContent = (config.note || '').replace('[price]', price);
        noteEl.hidden = !price;
      }

      if (cta) {
        cta.textContent = (empty ? config.ctaEmpty : config.cta) || '';

        if (empty) {
          cta.href = config.anchor;
          cta.removeAttribute('aria-disabled');
        } else if (option && option.variant) {
          cta.href = destination(option.variant);
          cta.removeAttribute('aria-disabled');
        } else {
          cta.removeAttribute('href');
          cta.setAttribute('aria-disabled', 'true');
        }
      }

      syncBar();
    };

    inputs.forEach((input) =>
      input.addEventListener('change', () => {
        update();
        sync();
      })
    );

    if (cta) {
      cta.addEventListener('click', (event) => {
        if (!current || !current.variant) return;

        event.preventDefault();

        const go = () => {
          window.location.href = destination(current.variant);
        };

        if (!ctaWritesCart) {
          go();
          return;
        }

        Promise.race([sync(), new Promise((resolve) => setTimeout(resolve, 1200))]).then(go, go);
      });
    }

    if (bar && trigger && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        triggerVisible = entry.isIntersecting;
        syncBar();
      }).observe(trigger);
    }

    update();
    root.setAttribute('data-ready', '');
  };

  const initAll = (scope) => {
    if (scope instanceof Element && scope.matches('.lp-bundle')) init(scope);
    scope.querySelectorAll('.lp-bundle').forEach(init);
  };

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();
